import { LitElement, html, css, nothing } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';
import { bannerStyles } from '../styles/banner-styles';

function iconFromSeverity(severity) {
  switch (severity) {
    case 'success': return 'fas fa-check-circle';
    case 'info': return 'fas fa-exclamation-circle';
    case 'cold': return 'fas fa-snowflake';
    default: return 'fas fa-exclamation-triangle';
  }
}

class BnBanner extends LitElement {
  static get properties() {
    return {
      icon: { type: String },
      title: { type: String },
      severity: { type: String }, // success, info, cold, warning, critical
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles, css`
      :host {
        display: block;
      }
      .banner {
        display: flex;
        align-items: stretch;
        gap: .5rem;
      }
      .icon {
        display: flex;
        align-items: flex-start;
        width: 1.2em;
        line-height: 1.5em;
      }
      :host([severity=critical]) .icon {
        color: var(--red-20);
      }
      :host([severity=warning]) .icon {
        color: var(--yellow-20);
      }
      :host([severity=info]) .icon {
        color: var(--blue-50);
      }
      :host([severity=success]) .icon {
        color: var(--green-15);
      }
      .content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }
      .title {
        font-weight: bold;
      }
    `];
  }

  render() {
    return html`
      <div class="banner banner--${this.severity}">
        ${this.renderIcon()}
        <div class="content">
          ${this.renderTitle()}
          <div class="body">
            <slot></slot>
          </div>
        </div>
        <slot name="actions"></slot>
      </div>
    `;
  }

  renderIcon() {
    let icon = this.icon === false ? undefined : (this.icon || iconFromSeverity(this.severity));

    if (!icon) {
      return nothing;
    }

    return html`
      <div class="icon">
        <bn-icon name="${icon}"></bn-icon>
      </div>
    `;
  }

  renderTitle() {
    if (!this.title) {
      return nothing;
    }

    return html`
      <div class="title">
        ${this.title}
      </div>
    `;
  }
}

window.customElements.define('bn-banner', BnBanner);
